import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// REDUX
import {
  setSelectedDriver,
  setShowDriversListModal,
  setShowSelectOrderToDriverModal,
} from "../../store/actions/driversSlice";
//APP COMPONENTS
import DriversModal from "../drivers/driversModal";
import SetOrderDriverModal from "../shipping/SetOrderDriverModal";
import SetOrderToDriverModal from "../shipping/SetOrderToDriverModal";
import { setShowDispatchOrdersModal } from "../../store/actions/ordersSlice";
// MATERIAL UI

const DriversModalMemoized = (props) => {
  const child = useMemo(() => {
    return <DriversModal {...props} />;
  }, []);

  return <>{child}</>;
};

export default function DriverManager() {
  const dispatch = useDispatch();

  const [localShowProviders, setLocalShowProviders] = useState(false);

  const showDriversListModal = useSelector(
    (state) => state.drivers.showDriversListModal
  );

  const showDispatchOrdersModal = useSelector(
    (state) => state.orders.showDispatchOrdersModal
  );

  const showDispatchOrdersModalProviders = useSelector(
    (state) => state.orders.showDispatchOrdersModalProviders
  );

  const showSelectOrderToDriverModal = useSelector(
    (state) => state.drivers.showSelectOrderToDriverModal
  );

  useEffect(() => {
    if (showDispatchOrdersModal) {
      setLocalShowProviders(showDispatchOrdersModalProviders);
    }
  }, [showDispatchOrdersModal, showDispatchOrdersModalProviders]);

  const handleCloseDriverListModal = (e) => {
    dispatch(setShowDriversListModal(false));
  };

  const handleCloseOrderDriverModal = () => {
    setLocalShowProviders(false);
    dispatch(setShowDispatchOrdersModal({ show: false, withProviders: false }));
  };

  const handleSetOrderToDriver = (driver = null) => {
    dispatch(setSelectedDriver(driver));
    dispatch(setShowSelectOrderToDriverModal(!showSelectOrderToDriverModal));
  };

  return (
    <>
      {showDriversListModal && (
        <DriversModalMemoized
          closeModal={handleCloseDriverListModal}
          setOrderToDriverModal={handleSetOrderToDriver}
        />
      )}

      {showDispatchOrdersModal && (
        <SetOrderDriverModal
          show={showDispatchOrdersModal}
          autoShowProviders={localShowProviders}
          closeModal={handleCloseOrderDriverModal}
        />
      )}

      {showSelectOrderToDriverModal && (
        <SetOrderToDriverModal closeModal={handleSetOrderToDriver} />
      )}
    </>
  );
}
